<app-modal-header (closeModal)="close()"></app-modal-header>
@defer (when !isShowPlaceholder) {
  <app-modal-body>
    <div class="fs-5 fw-medium mb-2" [innerHTML]="heading | translate"></div>
    <p class="mb-0" [innerHTML]="body | translate: { name }"></p>
    <app-your-interests
      [interests]="interests"
      [productsSelected]="productsSelected"
      [interestsSelected]="interestsSelected"
      (changeInterest)="changeInterest($event)"
      [peopleId]="peopleId"
      [title]="title"
    />
  </app-modal-body>
  <app-modal-footer classList="d-flex justify-content-center">
    <button
      class="btn btn-primary fw-medium rounded-5"
      type="button"
      (click)="sentUserInterest()"
      [disabled]="isHttpRequestRunning"
    >
      @if (isHttpRequestRunning) {
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      }
      {{ 'DONE' | translate }}
    </button>
  </app-modal-footer>
} @placeholder {
  @if (isShowPlaceholder) {
    <app-modal-body>
      <app-skeleton-general-list [class]="'mt-2'" [count]="4" />
    </app-modal-body>
  }
}
